import { DatePipe, NgTemplateOutlet } from "@angular/common";
import {
    Component,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { RouterLink } from "@angular/router";
import { IconComponent } from "@components/icon/icon.component";
import { ListColumnCheckboxDirective } from "@components/list/list-column-checkbox.directive";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent } from "@components/list/list.component";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import moment from "moment";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { InputMode, PromptInput } from "~app/common/components/modal/common/prompt-dialog/prompt-dialog.component";
import { RaskModalService } from "~app/common/components/modal/rask-modal.service";
import { ExternVirkeskopViewModel } from "../../models/externvirkeskop-models";
import { ExternVirkeskopService } from "../../services/extern-virkeskop.service";

@Component({
    selector: "rask-extern-virkeskop-search-result",
    templateUrl: "./extern-virkeskop-search-result.component.html",
    styleUrls: ["./extern-virkeskop-search-result.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ListComponent,
        ListColumnCheckboxDirective,
        ListColumnDirective,
        RouterLink,
        IconComponent,
        NgbPopover,
        NgTemplateOutlet,
        DatePipe
    ]
})
export class ExternVirkeskopSearchResultComponent implements OnInit, OnDestroy {
    protected searchResult: ExternVirkeskopViewModel[] = [];

    private readonly destroy$ = new Subject<void>();
    private readonly externVirkeskopsService = inject(ExternVirkeskopService);
    private readonly raskModalService = inject(RaskModalService);

    getIcon(status: string) {
        return this.externVirkeskopsService.getIcon(status);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngOnInit(): void {
        this.externVirkeskopsService.searchResult$.pipe(
            takeUntil(this.destroy$)
        ).subscribe(result => {
            this.searchResult = result;
        });
    }

    openLog(row: ExternVirkeskopViewModel) {
        this.externVirkeskopsService.getLog(row.id).subscribe(x => {
            const input = new PromptInput(InputMode.readOnly, {
                bodyField: {
                    value: x,
                    label: `Log: ${row.externBeteckning}`,
                    type: "text"
                }
            });
            this.raskModalService.prompt("Log", input, "xl").subscribe();
        });
    }

    protected getDokumentInfo(vm: ExternVirkeskopViewModel): string {
        const list = vm.dokument?.map(x => `${moment(x.updated).format("YYYY-MM-DD HH:mm")}: ${x.dokumentnyckel}`) ?? [];
        return list.join(", ");
    }

    protected onCheckedChange(): void {
        const selected = this.searchResult.filter(x => x.selected === true);
        this.externVirkeskopsService.selected$.next(selected);
    }
}
